import "./styles/App.css";
import { RouterProvider } from "react-router-dom";
import globalRouter from "./routes/globalRoute";
import useAuthentication from "./hooks/useAuthentication";
import SplashScreen from "./utilis/component/SplashScreen";
import { useEffect } from "react";
import { assetsUrl } from "./constants";
function App() {
  const { isLoading } = useAuthentication();
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `${assetsUrl}/lib/eidatoolkit.js`;
    script.async = true;
    script.onload = () => {
      console.log("Card sdk loaded!");
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  },[]);
  return isLoading ? (
    <SplashScreen />
  ) : (
    <RouterProvider router={globalRouter} />
  );
}
export default App;
